/** Original, local catalog samples. No network is needed to open these files. */
export const previewArtwork = `<svg xmlns="http://www.w3.org/2000/svg" width="1440" height="960" viewBox="0 0 1440 960">
<rect width="1440" height="960" fill="#e9e5dc"/><rect x="56" y="56" width="1328" height="848" rx="8" fill="#d3dace"/>
<path d="M56 650L560 190L1010 904H56Z" fill="#81998c"/><path d="M515 904L1040 260L1384 700V904Z" fill="#405e59"/>
<circle cx="1100" cy="225" r="88" fill="#efe4c9"/><path d="M56 788Q520 620 1384 810V904H56Z" fill="#b5bd9f"/>
<text x="112" y="151" font-family="sans-serif" font-size="20" letter-spacing="5" fill="#263b35">STUDIO NOTES / 01</text>
<text x="112" y="846" font-family="sans-serif" font-size="64" fill="#253b35">A little perspective.</text></svg>`;

export const makePreviewPdf = (): Uint8Array => {
  const titles = ['A little perspective.', 'Make room for the work.', 'Follow the details.', 'Ready to share.'];
  const notes = ['Studio Notes / Field guide', 'A calm place to start', 'Four views, one document', 'Keep something worth returning to'];
  const objects = ['', '<< /Type /Catalog /Pages 2 0 R >>', '<< /Type /Pages /Count 4 /Kids [4 0 R 6 0 R 8 0 R 10 0 R] >>', '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>'];
  for (let i = 0; i < 4; i++) {
    const stream = `0.96 0.95 0.92 rg 0 0 480 640 re f\n0.16 0.24 0.22 rg\nBT /F1 10 Tf 40 593 Td (STUDIO NOTES / 0${i + 1}) Tj ET\nBT /F1 25 Tf 40 540 Td (${titles[i]}) Tj ET\nBT /F1 12 Tf 40 510 Td (${notes[i]}) Tj ET\n${0.35 + i * 0.08} 0.52 0.47 rg 40 170 400 ${180 + i * 28} re f\n0.75 0.79 0.68 rg 80 210 ${110 + i * 40} 90 re f\n0.16 0.24 0.22 rg BT /F1 10 Tf 40 50 Td (design.estate / ${i + 1} of 4) Tj ET`;
    objects.push(`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 480 640] /Resources << /Font << /F1 3 0 R >> >> /Contents ${5 + i * 2} 0 R >>`, `<< /Length ${stream.length} >>\nstream\n${stream}\nendstream`);
  }
  let pdf = '%PDF-1.4\n';
  const offsets = [0];
  for (let i = 1; i < objects.length; i++) { offsets.push(pdf.length); pdf += `${i} 0 obj\n${objects[i]}\nendobj\n`; }
  const xref = pdf.length;
  pdf += `xref\n0 ${objects.length}\n0000000000 65535 f \n`;
  pdf += offsets.slice(1).map(offset => `${String(offset).padStart(10, '0')} 00000 n \n`).join('');
  pdf += `trailer\n<< /Size ${objects.length} /Root 1 0 R >>\nstartxref\n${xref}\n%%EOF`;
  return new TextEncoder().encode(pdf);
};

export const makePreviewAudio = (): Uint8Array => {
  const rate = 16000, samples = rate * 6;
  const bytes = new Uint8Array(44 + samples * 2);
  const view = new DataView(bytes.buffer);
  const write = (offset: number, text: string) => [...text].forEach((char, i) => view.setUint8(offset + i, char.charCodeAt(0)));
  write(0, 'RIFF'); view.setUint32(4, bytes.length - 8, true); write(8, 'WAVE'); write(12, 'fmt ');
  view.setUint32(16, 16, true); view.setUint16(20, 1, true); view.setUint16(22, 1, true);
  view.setUint32(24, rate, true); view.setUint32(28, rate * 2, true); view.setUint16(32, 2, true); view.setUint16(34, 16, true);
  write(36, 'data'); view.setUint32(40, samples * 2, true);
  const notes = [261.63, 329.63, 392, 523.25, 392, 329.63];
  for (let i = 0; i < samples; i++) {
    const t = i / rate, phase = t % 1;
    const envelope = Math.min(1, phase * 50) * Math.exp(-phase * 5);
    view.setInt16(44 + i * 2, Math.sin(t * notes[Math.floor(t)] * Math.PI * 2) * envelope * 6500, true);
  }
  return bytes;
};
